export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20cinema%20scene%20with%20warm%20golden%20spotlight%20illuminating%20floating%20film%20strips%20and%20elegant%20movie%20elements%20against%20deep%20burgundy%20theater%20curtain%20texture%20background%2C%20soft%20bokeh%20lights%2C%20cinematic%20atmosphere%2C%20stylized%20modern%20art%20composition%20with%20geometric%20shapes%20and%20warm%20amber%20gradient&width=1600&height=900&seq=hero-cinema-2026&orientation=landscape"
          alt="小草影院 - 院线大片与最新电影在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 mb-6 animate-fade-in-up">
                <i className="ri-fire-line text-accent-400 text-sm"></i>
                <span className="text-xs font-medium text-accent-300 whitespace-nowrap">
                  每日更新 · 高清画质 · 分类齐全
                </span>
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4 animate-fade-in-up-delay-1 font-heading">
                小草影院 - 院线大片与最新电影在线观看平台
              </h1>

              <p className="text-sm md:text-base font-medium text-accent-300 mb-6 animate-fade-in-up-delay-1">
                发现好电影，从这里开始
              </p>

              <p className="text-sm md:text-base text-white/75 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8 animate-fade-in-up-delay-2">
                小草影院汇集海量院线大片与最新上映电影，覆盖动作片、喜剧电影、科幻片、爱情片等丰富分类。片库每日更新，提供高清流畅的观影体验。无论你想看热门新片还是经典老片，小草影院都能帮你快速找到心仪之选，随时随地畅享精彩电影世界。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8 animate-fade-in-up-delay-2">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/20">
                    <i className="ri-movie-line text-primary-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-white/80 whitespace-nowrap">
                    片库 <strong className="text-white">10,000+</strong> 部影片
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500/20">
                    <i className="ri-refresh-line text-accent-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-white/80 whitespace-nowrap">
                    每日 <strong className="text-white">30+</strong> 部更新
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/20">
                    <i className="ri-shield-check-line text-secondary-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-white/80 whitespace-nowrap">
                    高清 <strong className="text-white">流畅</strong> 观影
                  </span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 animate-fade-in-up-delay-3">
                <button
                  onClick={() => handleScroll('#cards')}
                  className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  立即探索影片
                </button>
                <button
                  onClick={() => handleScroll('#ranking')}
                  className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-lg border border-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-bar-chart-line mr-2"></i>
                  查看热映榜单
                </button>
              </div>
            </div>

            <div className="flex-1 w-full hidden lg:block animate-fade-in-up-delay-2">
              <div className="relative">
                <div className="absolute -inset-4 bg-primary-500/10 rounded-2xl blur-2xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20collage%20with%20floating%20movie%20poster%20fragments%20in%20warm%20amber%20and%20crimson%20tones%2C%20golden%20spotlight%20effect%2C%20film%20reel%20silhouette%2C%20artistic%20composition%20with%20soft%20gradients%2C%20theatrical%20atmosphere%2C%20luxurious%20cinema%20aesthetic&width=600&height=750&seq=hero-film-collage&orientation=portrait"
                  alt="小草影院电影精选合集"
                  className="relative w-full max-w-md mx-auto rounded-xl object-cover"
                  style={{ aspectRatio: '4/5' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}